/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { ADD_LOCAL_RESERVATION, DELETE_LOCAL_RESERVATION } from '../constants/actions';

export function addLocalReservation(reservation) {
    return {
        type: ADD_LOCAL_RESERVATION,
        payload: reservation,
    };
}

export function deleteLocalReservation() {
    return {
        type: DELETE_LOCAL_RESERVATION,
    };
}
